import { defineStore } from "pinia";
import {
  defaultAppConfig,
  getAppConfig,
  hasAppConfig,
} from "@/config/app-config";
import type { AppConfig } from "@/config/app-config.types";

export const useConfigStore = defineStore("config", {
  state: (): AppConfig =>
    hasAppConfig() ? { ...getAppConfig() } : { ...defaultAppConfig },

  getters: {
    isClient(state) {
      return (name: string) => state.clientName === name;
    },
  },

  actions: {
    hydrate(config?: AppConfig) {
      Object.assign(this, config ?? getAppConfig());
    },
  },
});
